module.exports = __webpack_public_path__ + "img/icon-ticket_type.37366a4d.svg";